import axios from "axios";

import * as types from "./actionTypes";
import library from "modules/library";

export const getLibraries = () => (dispatch, getStore) => {
  const { checkedControls } = getStore().controls;
  const { filter } = getStore().search;
  const formattedControls = {};
  checkedControls.map(control => (formattedControls[control] = 1));
  if (Object.keys(filter).length) {
    formattedControls["search"] = filter;
  }

  axios
    .get(
      process.env.REACT_APP_API_URL +
        "/map/libraries/" +
        JSON.stringify(formattedControls)
    )
    .then(({ data }) => {
      return dispatch({
        type: types.LIBRARIES_GET,
        data
      });
    });
};

export const getAllLibraries = () => dispatch => {
  axios
    .get(process.env.REACT_APP_API_URL + "/map/libraries")
    .then(({ data }) => {
      return dispatch({
        type: types.LIBRARIES_GET,
        data
      });
    });
};

export const selectLibrary = libraryId => dispatch => {
  return Promise.resolve()
    .then(() =>
      dispatch({
        type: types.SELECT_LIBRARY,
        libraryId
      })
    )
    .then(() => dispatch(library.actions.getLibrary()));
};



// WEBPACK FOOTER //
// ./src/modules/map/actions.js